var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralCertificationFollowupcost = function SvgGeneralCertificationFollowupcost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF540F"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m6.195 2.521 3.23 2.896-3.615 4.03a2.169 2.169 0 1 1-3.229-2.895l.694-.774 1.07.959a.253.253 0 0 0 .338-.377l-1.07-.96.695-.774 1.036.93a.253.253 0 0 0 .338-.377l-1.036-.93z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.992 1.484 1.385 1.242L8.365 4.97 6.98 3.73z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.719,
    height: 2.698,
    x: 2.801,
    y: 9,
    rx: 0.359,
    transform: "rotate(41.883 2.8 9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.831,
    height: 5.867,
    x: 10.291,
    y: 5.638,
    rx: 0.415,
    transform: "rotate(131.883 10.291 5.638)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.831,
    height: 2.902,
    x: 10.869,
    y: 2.937,
    rx: 0.415,
    transform: "rotate(131.883 10.869 2.937)"
  }))));
};
export default SvgGeneralCertificationFollowupcost;